export interface FanSource {
  id: string;
  label: string;
  detail: string;
  scans: number;
  joins: number;
}

export const fanSourcesStorageKey = 'artistos-fan-capture-sources';
export const fanSourcesUpdatedEvent = 'artistos:fan-capture-sources-updated';

const defaultFanSources: FanSource[] = [
  { id: 'gruene-sept-14', label: 'Gruene Hall · Sept 14', detail: 'Merch table card', scans: 286, joins: 118 },
  { id: 'tour-poster', label: 'Fall tour poster', detail: 'Venue lobby poster', scans: 194, joins: 73 },
  { id: 'social-bio', label: 'Instagram bio', detail: 'Profile link', scans: 832, joins: 346 },
  { id: 'dust-denim', label: 'Dust & Denim release', detail: 'Smart-link landing page', scans: 511, joins: 202 },
];

export const fanSources = defaultFanSources;

export function getFanSources(): FanSource[] {
  try {
    const stored = window.localStorage.getItem(fanSourcesStorageKey);
    const sources = stored ? JSON.parse(stored) : defaultFanSources;
    return Array.isArray(sources) ? sources.filter(isFanSource) : defaultFanSources;
  } catch {
    return defaultFanSources;
  }
}

export function createFanSource(source: Omit<FanSource, 'id' | 'scans' | 'joins'>): FanSource | null {
  try {
    const record: FanSource = { ...source, id: createSourceId(source.label), scans: 0, joins: 0 };
    const sources = getFanSources();
    if (sources.some((item) => item.id === record.id)) record.id = `${record.id}-${Date.now().toString().slice(-5)}`;
    const updated = [record, ...sources];
    window.localStorage.setItem(fanSourcesStorageKey, JSON.stringify(updated));
    window.dispatchEvent(new CustomEvent(fanSourcesUpdatedEvent, { detail: updated }));
    return record;
  } catch {
    return null;
  }
}

function createSourceId(label: string) {
  const slug = label.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  return slug || `capture-${Date.now()}`;
}

function isFanSource(value: unknown): value is FanSource {
  const source = value as Partial<FanSource>;
  return typeof source?.id === 'string' && typeof source.label === 'string' && typeof source.detail === 'string' && typeof source.scans === 'number' && typeof source.joins === 'number';
}

export const fanMetrics = [
  { label: 'Fan club members', value: '12,840', detail: '+640 this month', positive: true },
  { label: 'QR scans', value: '1,823', detail: '+22% this month', positive: true },
  { label: 'Scan → join rate', value: '41.2%', detail: 'Top quartile', positive: true },
  { label: 'VIP Club members', value: '1,184', detail: '9.2% of fans', positive: false },
];

export const welcomeBenefits = [
  'First access to tickets and presales',
  'Unreleased songs, demos and acoustic sessions',
  'Texas tour dates before everyone else',
];
